<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        API Token For Client
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="keyList"
      :options.sync="options"
      :server-items-length="total"
      :loading="tokenLoader"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:item.client_key_status="{ item }">
        <v-switch
          v-model="item.client_key_status"
          @change="tokenStatusChange(item)"
          v-if="checkPermission('app_client:client_generate_token_toggle')"
        ></v-switch>
        <span v-else>{{ item.client_key_status }}</span>
      </template>
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col
            cols="12"
            md="6"
            class="d-flex flex-column align-left justify-center mt-2 pt-0"
          >
            <v-toolbar-title class="pl-4 text-h6"> Clients </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end pt-5">
            <v-btn
              color="primary"
              dark
              v-if="
                checkPermission('app_client:client_generate_token_create') &&
                selectedClient
              "
              class="mb-2 mt-2 text-end mr-4"
              v-bind="attrs"
              v-on="on"
              small
              @click="token()"
              >Generate new Token</v-btn
            >
            <v-select
              label="Client"
              :rules="[(v) => !!v || 'CLient is required.']"
              class="required pt-0 pr-4"
              v-model="selectedClient"
              :items="clients"
              hide-no-data
              hide-details
              item-text="name"
              item-value="id"
              @change="clientTypeList()"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="mt-3"></v-divider>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    headers: [
      {
        text: "Token",
        value: "client_key",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "client_key_status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    tokenLoader: false,
    keyList: [],
    dialog: false,
    selectedClient: null,
    clients: [],
  }),
  created() {
    if (this.$route.params.id !== undefined) this.fetchtoken();
    this.selectedClient = this.$route.params.id;
    this.fetchCLientList();
  },
  methods: {
    ...mapActions([
      "snackBar",
      "generateToken",
      "getTokenList",
      "updateTokenList",
      "fetchClient",
    ]),
    fetchCLientList() {
      this.fetchClient().then((res) => {
        this.clients = res.data;
      });
    },
    fetchtoken() {
      this.tokenLoader = true;
      this.getTokenList(this.$route.params.id)
        .then((res) => {
          this.tokenLoader = false;
          this.keyList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.tokenLoader = false;
        });
    },
    clientTypeList() {
      this.$route.params.id = this.selectedClient;
      this.$router.replace({
        params: {
          id: this.$route.params.id,
        },
      });
      this.fetchtoken();
    },
    async token() {
      await this.generateToken(this.$route.params.id).then((res) => {
        if (res.data.code == "SUCCESS") {
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.fetchtoken();
        }
      });
    },

    tokenStatusChange(item) {
      let payload = {
        client_id: this.$route.params.id,
        id: item.id,
        status: item.client_key_status,
      };
      this.updateTokenList(payload).then((res) => {
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
        this.tokenListDialog = false;
      });
    },
  },
};
</script>
